export const PHOTO_CAPTURE_CONSTRAINTS = {
  width: { ideal: 2560 },
  height: { ideal: 1440 },
};

export const VIDEO_CAPTURE_CONSTRAINTS = {
  width: { ideal: 1920 },
  height: { ideal: 1080 },
  frameRate: { ideal: 30, max: 30 },
};

export const VIDEO_CAPTURE_MIME_TYPES = [
  'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
  'video/mp4',
  'video/webm;codecs=vp9,opus',
  'video/webm;codecs=vp8,opus',
  'video/webm',
];

export const getSupportedVideoCaptureMimeTypes = () => {
  if (typeof window === 'undefined' || !window.MediaRecorder) {
    return [];
  }

  return VIDEO_CAPTURE_MIME_TYPES.filter(mimeType =>
    window.MediaRecorder.isTypeSupported(mimeType)
  );
};

const mimeTypeMatchesAllowedType = (mimeType, allowedType) => {
  const normalizedMimeType = mimeType.split(';')[0];

  if (allowedType.endsWith('/*')) {
    const prefix = allowedType.slice(0, -2);
    return normalizedMimeType.startsWith(`${prefix}/`);
  }

  return normalizedMimeType === allowedType;
};

export const getPreferredVideoCaptureMimeType = allowedFileTypes => {
  const allowedTypes = (allowedFileTypes || '')
    .split(',')
    .map(type => type.trim())
    .filter(Boolean);

  return (
    getSupportedVideoCaptureMimeTypes().find(mimeType =>
      allowedTypes.some(allowedType =>
        mimeTypeMatchesAllowedType(mimeType, allowedType)
      )
    ) || ''
  );
};
